import { render, staticRenderFns } from "./VerificationError.vue?vue&type=template&id=63c866be&scoped=true"
import script from "./VerificationError.vue?vue&type=script&lang=js"
export * from "./VerificationError.vue?vue&type=script&lang=js"
import style0 from "./VerificationError.vue?vue&type=style&index=0&id=63c866be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c866be",
  null
  
)

export default component.exports